import { IController } from 'angular';

import { ISchool } from '../../../../../ng2/shared/typings/interfaces/school.interface';
import { SpinnerModal } from '../../../../shared/modals/status-spinner/status-spinner.service';
import { ISdcStore } from '../../../flux/sdc-store.interface';

export class RegentsPlanningWizardCtrl implements IController {
  static $inject: string[] = ['$scope', 'SpinnerModal', 'SDCStore'];

  public uiReady: boolean = false;
  public currentSchool: ISchool;
  public currentUser;

  constructor(private $scope, private SpinnerModal: SpinnerModal, private SDCStore: ISdcStore) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.SpinnerModal.deactivateSpinner();
        this.currentSchool = this.SDCStore.getSchool();
        this.uiReady = true;
      }
    });
  }
}
